module.exports = __webpack_public_path__ + "static/img/17069D_1_2_C_20210406_fit.8b02172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17069D_1_2_C_20210406_fit.png
// module id = 03JU
// module chunks = 0